module.exports = __webpack_public_path__ + "img/banner1.b5237848.jpg";